"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRedeemerKey = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const __1 = require("../..");
const findRedeemerKey = async ({ iouMint, redemptionMint, }) => {
    return web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("Redeemer"),
        iouMint.toBytes(),
        redemptionMint.toBytes(),
    ], __1.QUARRY_ADDRESSES.Redeemer);
};
exports.findRedeemerKey = findRedeemerKey;
//# sourceMappingURL=pda.js.map